import { useEffect } from 'react';
import { MOBILE_DIALOG_DESKTOP_BREAKPOINT } from '../constants';

export const useCloseOnResize = ({
  open,
  onClose,
  breakpoint = MOBILE_DIALOG_DESKTOP_BREAKPOINT,
}: {
  open: boolean;
  onClose: () => void;
  breakpoint?: number;
}) => {
  useEffect(() => {
    if (!open) return;

    const handleResize = () => {
      if (window.innerWidth >= breakpoint) {
        onClose();
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [open, onClose, breakpoint]);
};
